(function () {
  var HUBSPOT_ID = '25733416'; // <-- your real Portal ID

  // Don’t run in Theme Editor preview (prevents double loads while editing)
  if (window.Shopify && (Shopify.designMode || Shopify.previewBarInjector)) return;

  function loadHubspot(){
    if (document.getElementById('hs-script-loader')) return;
    var s = document.createElement('script');
    s.id = 'hs-script-loader';
    s.async = true;
    s.defer = true;
    s.src = 'https://js.hs-scripts.com/' + HUBSPOT_ID + '.js';
    document.head.appendChild(s);
    try { console.log('[privacy] HubSpot loaded'); } catch(e){}
  }

  function allowed(){
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { return cp && cp.analyticsProcessingAllowed() && cp.marketingAllowed(); }
    catch(e){ return false; }
  }

  function tryLoad(){ if (allowed()) loadHubspot(); }

  document.addEventListener('consentApiReady', tryLoad);
  document.addEventListener('visitorConsentCollected', tryLoad);   // new event
  document.addEventListener('trackingConsentAccepted', tryLoad);   // legacy event
  if (window.Shopify && window.Shopify.customerPrivacy) tryLoad(); // late-init fallback
})();
